import { GetAllAgencyCustomersByAgencyIdResponseBodyType } from "@intelligems/ig-types";
import { adminKeys } from "@src/api/queryKeys";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { api } from "../api";

const getAgencyCustomersByAgencyId = async (agencyId: string) => {
  const resp = await api.get<GetAllAgencyCustomersByAgencyIdResponseBodyType>(
    `/v2/admin/agencies/${agencyId}/customers`
  );
  return resp.data;
};

export const useGetAgencyCustomersByAgencyId = (
  agencyId: string
): UseQueryResult<GetAllAgencyCustomersByAgencyIdResponseBodyType, Error> => {
  return useQuery<GetAllAgencyCustomersByAgencyIdResponseBodyType, Error>({
    queryKey: adminKeys.agencyCustomers(agencyId),
    queryFn: async () => getAgencyCustomersByAgencyId(agencyId),
  });
};
